import { pipe } from 'fp-ts/function';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withAppClockService } from '@mews/framework';
import { createScopedActions } from '@mews-commander/utils';
import { CommanderSidebar } from '../../../../components/sidebar';
import { closeSidebar } from '../../actions';
import { getSidebarDateString, isSidebarOpened } from '../../selectors';
import RestrictionsDetailList from './RestrictionsDetailList';

const RestrictionsSidebar = pipe(
    RestrictionsDetailList,
    CommanderSidebar,
    connect(
        createStructuredSelector({
            opened: isSidebarOpened,
            // @ts-expect-error https://mews.myjetbrains.com/youtrack/issue/kanban-4230/Types-for-Commander-Sidebar
            title: getSidebarDateString as () => JSX.Element,
        }),
        createScopedActions(
            {
                onClose: closeSidebar,
            },
            { scopeName: 'serviceId' }
        )
    ),
    withAppClockService
);

export default RestrictionsSidebar;
